/**
 * 화면ID : COMCDD001_00FP
 * ASIS : 인터넷뱅킹 H03501.jsp
 */
import { Trans, useTranslation } from 'react-i18next';
import { PropsWithPopup } from 'scbk-services';
import { Button, common, DialogWrapper } from 'scbk-ui-web';
import { DarkModeResult } from '../GlobalComponents/types/DarkModeResult';
// import { Trans } from 'react-i18next';

interface Props extends PropsWithPopup {
  onComplete?: (result: DarkModeResult) => void;
}

const DarkModePopupComponent: React.FC<Props> = ({ isOpen, setOpen, onComplete }) => {
  // 다국어 처리
  const { t } = useTranslation();

  return (
    <DialogWrapper
      open={isOpen}
      setOpen={setOpen}
      onClose={() => {
        console.log('### onClose');
        onComplete?.({ darkChange: 'N', noticeShowYn: 'Y' });
      }}
      footerBottom={
        <div className="text-center mt-5">
          <Button
            variant="grayLink"
            size="link"
            onClick={() => {
              setOpen?.(false);
              console.log('### change dark mode & notice no darkmode popup');
              onComplete?.({ darkChange: 'N', noticeShowYn: 'N' });
            }}
          >
            {t('DarkMode.001', {
              defaultValue: '그만보기',
            })}
          </Button>
        </div>
      }
      footer={[
        {
          type: 'secondary',
          title: t('DarkMode.002', {
            defaultValue: '다음에',
          }),
          handler: () => {
            console.log('### next');
            onComplete?.({ darkChange: 'N', noticeShowYn: 'Y' });
          },
          hasClose: true,
        },
        {
          type: 'primary',
          title: t('DarkMode.003', {
            defaultValue: '다크모드 이용',
          }),
          handler: () => {
            console.log('### change dark mode');
            onComplete?.({ darkChange: 'Y', noticeShowYn: 'Y' });
          },
          hasClose: true,
        },
      ]}
    >
      <h3 className="page-heading-title mb-3">
        <Trans t={t} i18nKey="DarkMode.004" components={[<br />]}>
          편한뱅킹과 함께
          <br />
          다크모드 화면도 사용해 보세요!
        </Trans>
      </h3>
      <p className="text-primary-02 mb-8">
        {t('DarkMode.005', {
          defaultValue: '다크모드를 사용하면 눈이 덜 피로해요.',
        })}
      </p>
      <div className=" mx-auto mb-10">
        <img
          src={common.asset(`/ui/images/keylanding/img_landing_02.png`)}
          alt={t('DarkMode.006', {
            defaultValue: '다크모드',
          })}
        />
      </div>
    </DialogWrapper>
  );
};

export default DarkModePopupComponent;
